import React, { useContext } from 'react';
import { PageContext } from '@leuven2030/framework/Page/Page';
import Moment from 'react-moment';
import 'twin.macro';
const NewsArticleFooter = (props) => {
  const {
    prismic: {
      news_page: { published_label },
      news_article: { published_date }
    }
  } = useContext(PageContext);

  return (
    <div {...props}>
      <div tw="space-x-2 text-gray-500 flex items-center">
        <span>{published_label}</span>
        <Moment
          tw="tracking-wide uppercase text-sm block"
          parse="YYYY-MM-DD"
          format="DD MMMM YYYY"
        >
          {published_date}
        </Moment>
      </div>
    </div>
  );
};

export default NewsArticleFooter;
